import { Component } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { AuthenticationService, DealerService, SpinnerService } from '../services';
import { HttpClient } from '@angular/common/http';
import { Router} from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as FileSaver from 'file-saver';

@Component({
    templateUrl: 'home.component.html',
})
export class HomeComponent {
    dealerLegacySources:any;
    legacySource:any;
    dealers: any[];
    dealerCols: any;
    customMessage: any;
    currentUser: any;
    displayDlrDltDialog: boolean = false;
    dlrGuid: any;
    searchText: string;
    topMenuBar: boolean;
    viewdealerinfo: boolean = false;
    public syncTopMenuClick: boolean = true;
    DealerGuid: string;
    Oems: any;
    oem: any = 'All';
    show: boolean = false;
    toggleClass: string = "fa fa-angle-double-down";
    pager: any;
    NoofPages: number=10;
    DealerDeleteForm: FormGroup;
    dlrSource: any;
    dataSourceId: any = 'All';
    dealerMappings: any;
    mode: any = 'desc';
    sortValue: any = 'updateddt';
    excelDealers: any;
    downloadExcelFlag: any = 0;
    legacySourceId:any =0;
   
    constructor(private dealerService: DealerService,
        private router: Router,
        private fb: FormBuilder,
        private spinnerService: SpinnerService,
        private authenticationService: AuthenticationService,
        private http: HttpClient) { 
            authenticationService.topMenuBar.subscribe(value => {
                this.syncTopMenuClick = !value;
            });
        }
    ngOnInit() {
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
        this.DealerDeleteForm = this.fb.group({
            DeleteComments: ['', [Validators.required]],
        });
        this.searchText = "";
        this.getOems();
        this.getsources();
        this.getDealer(1);
        this.getLegacysources();
    }
    bindDealerInfo() {
        this.getDealer(1);
    }
    sortChange(){
        if(this.mode != undefined && this.sortValue != undefined){
            this.bindDealerInfo();
        }
    }
    getDealer(page) {
        this.spinnerService.start();
        this.dealerService.getDealers(this.searchText,this.oem,this.dataSourceId,this.legacySourceId,this.mode,this.sortValue,this.NoofPages,page,this.downloadExcelFlag).pipe(first()).subscribe(dealers => {
            this.http.get('assets/data/dealer-header.json').subscribe(results => {
                this.dealerCols = results;
                if(this.downloadExcelFlag == 1){
                    this.excelDealers = dealers;
                    this.excelDealers.forEach(function(x){
                        x.OEMCode = x.OemCode;
                        delete x.CreatedBy;
                        delete x.ListDealerMapping;
                        delete x.ListLastServiceDates;
                        delete x.DealerId;
                        delete x.SearchText;
                        delete x.UpdatedBy;
                        delete x.DpsClientId;
                        delete x.OcClientId;
                        delete x.AlClientId;
                        delete x.OemCode;
                        delete x.PageSize;
                        delete x.DealerSource;
                        delete x.PageNo;
                        delete x.Zip;
                        delete x.SalesforceID;
                        delete x.ListLastSaleDates;
                        delete x.DeleteComments;
                        delete x.DataSourceId;
                        delete x.Mode;
                        delete x.SortValue;
                        delete x.OpcodeProcessedDate;
                        delete x.DealerMappingId;
                        delete x.DealerGuid;
                        delete x.ParentDealerId;
                        delete x.TimeZone;
                        delete x.IsOpcodeRequired;
                        delete x.DealerCount;
                        delete x.EffectiveDate;
                        delete x.DealerMappingDeleteFlag;
                        delete x.TotalRecordCount;
                    });
                    this.exportExcel();
                    
                }else{
                    if (dealers.length > 0) {
                        this.pager = this.dealerService.getPager(dealers[0].TotalRecordCount, page, this.NoofPages);
                        this.dealers = dealers;
                    }
                    else {
                        this.dealers = [];
                        this.customMessage = "No recors found";
                    }
                }
                this.downloadExcelFlag = 0;
                this.spinnerService.stop();
            });
        }),
        error => {
            this.spinnerService.stop();
        };
    }
    setPage(page: number, campaignMebId) {
        if (page < 1 || page > this.pager.totalPages) {
            return;
        }
        this.getDealer(page)
    }
    onChange($event, page) {
        this.getDealer(page);
    }
    onClickOutside(event) {
        this.authenticationService.dynamicOutClick.next("true");
    }
    backtogrid(){
        this.viewdealerinfo = !this.viewdealerinfo;
    }
    AddDealer(guid) {
        this.router.navigate(['/dealer/endlr', guid]);
    }
    DeleteDealer(guid) {
        this.dlrGuid = guid;
        this.DealerDeleteForm.controls['DeleteComments'].setValue(null);
        this.displayDlrDltDialog = true;
    }
    YesDlrDlt() {
        this.spinnerService.start();
        this.dealerService.dealerDelete(this.dlrGuid,this.DealerDeleteForm.controls.DeleteComments.value,this.currentUser.userName).pipe(first()).subscribe(result => {
            this.displayDlrDltDialog = false;
            this.dealers = this.dealers.filter(item => item.DealerGuid !== this.dlrGuid);
            this.spinnerService.stop();
        })
    }
    NoDlr() {
        this.displayDlrDltDialog = false;
    }
    getOems() {
        this.dealerService.getOemList().pipe(first()).subscribe(data => {
            this.Oems = data;
        });
    }
    searchClick(show){
        if(show == false){
            this.toggleClass = 'fa fa-angle-double-down';
        }else{
            this.toggleClass = 'fa fa-angle-double-up';
        }
    }
    Leftmenuclick() {
        this.topMenuBar = !this.topMenuBar;
        this.authenticationService.topMenuBar.next(this.topMenuBar);
    }
    getsources(){
        this.dealerService.getDealerSources(0).pipe(first()).subscribe(dealerSources => {
            this.dlrSource = dealerSources.ListDlrSource;
            //this.spinnerService.stop();
        });
    }
    getLegacysources(){
        this.dealerService.getLegacyDealerSources().pipe(first()).subscribe(dealerLegacySources => {
            this.legacySource = dealerLegacySources;
            //this.spinnerService.stop();
        });
    }
    downloadexcel(downloadExcelFlag){
        this.downloadExcelFlag = downloadExcelFlag;
        this.getDealer(1);
        this.spinnerService.start();
    }
    exportExcel() {
        import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(this.excelDealers);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, "dealers");
        });
    }
    saveAsExcelFile(buffer: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data: Blob = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            let oem = this.oem;
            if( this.oem == 'All'){
                oem = 'All_OEMs'
            }
            FileSaver.saveAs(data, fileName + '_export_' + oem  + EXCEL_EXTENSION);
        });
        this.spinnerService.stop();
    }
}